import React from 'react'
import UnderConstruction from '../UnderConstruction'


const CreatePresale = () => {
  return (
    <div>
      <UnderConstruction />
    </div>
  )
}

export default CreatePresale